import React from 'react';

import clsx from 'clsx';
import { ButtonBase, Typography, makeStyles, Theme, createStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

import { ChatBubbleSide } from './ChatBubble';

interface Props {
  // The bubble it sits in, so it reads on either colour.
  side: ChatBubbleSide;
  title: string;
  text: string;
  // Jumps to the quoted message.
  onClick?: () => void;
}

// The replied-to message inside a bubble, as in Telegram: an accent line, who
// wrote it and the first line of what they wrote.
export const ChatQuote: React.FC<Props> = ({ side, title, text, onClick }) => {
  const classes = useStyles();

  return (
    <ButtonBase
      component="div"
      className={clsx(classes.root, side === 'out' ? classes.out : classes.in)}
      onClick={onClick}
      disabled={!onClick}
      aria-label={`Reply to ${title}: ${text}`}
    >
      <Typography component="span" className={classes.title}>
        {title}
      </Typography>
      <Typography component="span" className={classes.text}>
        {text}
      </Typography>
    </ButtonBase>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      width: '100%',
      minWidth: 160,
      margin: '2px 0 6px',
      padding: '3px 8px 4px 10px',
      borderRadius: 6,
      borderLeft: '3px solid',
      textAlign: 'left',
      cursor: 'pointer',
    },
    in: {
      borderLeftColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      '& $title': { color: theme.palette.primary.main },
    },
    out: {
      borderLeftColor: theme.palette.common.white,
      backgroundColor: alpha(theme.palette.common.white, 0.16),
      color: theme.palette.common.white,
    },
    title: { fontSize: 13, fontWeight: 600, lineHeight: '18px' },
    text: {
      fontSize: 13,
      lineHeight: '18px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      opacity: 0.9,
    },
  })
);
